<template>
  <div>
    <div class="page-header">
      <div class="pageTitle">
        <div class="pageName">{{ page.title }}</div>
        <!-- 提交按钮 -->
        <!-- <div class="pageButton">
          <button type="button" class="btn btn-primary" @click="clkApply()">
            {{ "Apply" }}
          </button>
          <span style="margin-left: 10px">
            <button
              type="button"
              class="btn btn-default"
              style="min-width: 77px"
              @click="clkCancel()"
            >
              {{ "Cancel" }}
            </button>
          </span>
        </div> -->
      </div>
    </div>
    <div class="row">
      <p style="margin: 20px 15px 10px">
        {{ page.desc }}
      </p>
    </div>
    <div>
      <tabs v-model="activeIndex">
        <!--Interface Config-->
        <pane label="Interface Config">
          <ip-config-if></ip-config-if>
        </pane>
        <!--Address Config-->
        <pane label="Address Config">
          <ip-config-if-addr></ip-config-if-addr>
        </pane>
        <!--Static Route-->
        <pane label="Static Route">
          <ip-config-static></ip-config-static>
        </pane>
      </tabs>
    </div>
  </div>
</template>

<script>
import en from "@/lang/en-US.js"
import BlockCntr from "@/components/BlockCntr.vue"
import Tabs from "@/components/Tabs.vue"
import Pane from "@/components/Pane.vue"
import IpConfigIf from "@/views/IpConfigIf.vue"
import IpConfigIfAddr from "@/views/IpConfigIfAddr.vue"
import IpConfigStatic from "@/views/IpConfigStatic.vue"

export default {
  components: {
    BlockCntr,
    Tabs,
    Pane,
    IpConfigIf,
    IpConfigIfAddr,
    IpConfigStatic
  },
  data() {
    return {
    	page: en.page.ipconfig,
      activeIndex: 0
    }
  },
}
</script>
